import { stitchTransitionText as text } from './stitch-transition.text.js';
/** Brief loading overlay shown while a project canvas is prepared. */

const STITCH_LOADING_MESSAGES = [
  text.openingCanvas,
  text.loadingFiles,
  text.syncingTasks,
];

export interface StitchTransitionHandle {
  finish(): Promise<void>;
  updateMessage(msg: string): void;
}

export function playStitchTransition(projectName: string, parent: HTMLElement = document.body): StitchTransitionHandle {
  const overlay = document.createElement('div');
  overlay.className = 'stitch-transition-overlay';

  const card = document.createElement('div');
  card.className = 'stitch-transition-card';

  const spark = document.createElement('div');
  spark.className = 'stitch-transition-spark';
  spark.innerHTML = `
    <svg viewBox="0 0 24 24" width="32" height="32" fill="none">
      <path d="M12 0C12 6.627 6.627 12 0 12C6.627 12 12 17.373 12 24C12 17.373 17.373 12 24 12C17.373 12 12 6.627 12 0Z" fill="url(#stitch-grad)"/>
      <defs>
        <linearGradient id="stitch-grad" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop stop-color="var(--md-sys-color-primary)"/>
          <stop offset="0.5" stop-color="var(--md-sys-color-inverse-primary)"/>
          <stop offset="1" stop-color="var(--md-sys-color-tertiary)"/>
        </linearGradient>
      </defs>
    </svg>
  `;

  const title = document.createElement('h3');
  title.className = 'stitch-transition-title';
  title.textContent = projectName || text.loadingProject;

  const messageText = document.createElement('p');
  messageText.className = 'stitch-transition-message';
  messageText.textContent = STITCH_LOADING_MESSAGES[0] ?? '';

  const progressBar = document.createElement('div');
  progressBar.className = 'stitch-transition-progress';
  const progressInner = document.createElement('div');
  progressInner.className = 'stitch-transition-progress-bar';
  progressBar.append(progressInner);

  card.append(spark, title, messageText, progressBar);
  overlay.append(card);
  parent.append(overlay);

  // Trigger entrance animation
  requestAnimationFrame(() => {
    overlay.classList.add('is-active');
  });

  let messageIndex = 0;
  const interval = window.setInterval(() => {
    messageIndex = (messageIndex + 1) % STITCH_LOADING_MESSAGES.length;
    messageText.style.opacity = '0';
    setTimeout(() => {
      messageText.textContent = STITCH_LOADING_MESSAGES[messageIndex] ?? '';
      messageText.style.opacity = '1';
    }, 150);
  }, 750);

  return {
    updateMessage(msg: string) {
      messageText.textContent = msg;
    },
    async finish(): Promise<void> {
      clearInterval(interval);
      progressInner.style.width = '100%';
      messageText.textContent = text.ready;
      overlay.classList.add('is-finished');
      await new Promise(resolve => setTimeout(resolve, 320));
      overlay.remove();
    }
  };
}
